import { createUseStyles } from 'react-jss';

export default createUseStyles({
  iconWrapper: {
    fontSize: '96px',
    display: 'flex',
    justifyContent: 'center'
  },
});
